import { render, staticRenderFns } from "./DeleteAccountSection.vue?vue&type=template&id=f4803946&"
import script from "./DeleteAccountSection.vue?vue&type=script&lang=js&"
export * from "./DeleteAccountSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports